import React from "react";
import RouteSwitch from "../../routes/routeSwitch";

function PageWrapper() {
  return <RouteSwitch />;
}

export default PageWrapper;
